import Icon from 'components/Icon';

const LoginHeader = ({ title, text, showIcon = false }) => (
  <div className="login__header-wrap _mb-36">
    {showIcon && (
      <div className="login__icon-success-wrap">
        <Icon className="login__icon-success" icon="check-big" />
      </div>
    )}
    <div className="title login__title _mb-21">{title}</div>
    <div className="text login__text">{text}</div>
  </div>
);

export default LoginHeader;
